module.exports = __webpack_public_path__ + "img/business-page-banner.95eeb15c.jpg";